
import React, { memo } from 'react';
import SectionHeading from '../ui/SectionHeading';

interface MajorSectionHeadingProps {
  content: string;
  index: number;
}

const MajorSectionHeading: React.FC<MajorSectionHeadingProps> = ({ content, index }) => {
  return (
    <div key={index} className="mb-6 pt-4">
      <SectionHeading 
        text={content} 
        level="h2"
        className="text-white pb-2 border-b border-gray-800"
      />
    </div>
  );
};

export default memo(MajorSectionHeading);
